import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';

export default class Track extends Phaser.GameObjects.Container {
  constructor(scene, paths) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    // this.debugShape = new createjs.Shape();
    // this.addChild(this.debugShape);

    this.totalLineLength = 0;
    this.paths = paths;
    this.pathDataArr = [];

    // store path points and total lengths
    for (let i = 0; i < this.paths.length; i++) {
      const pathObj = {};
      pathObj.points = this.paths[i];
      pathObj.startDistance = this.totalLineLength;
      const d = this.getCurveData(this.paths[i],pathObj.startDistance);
      pathObj.arcLengths = d.arcLengths;
      pathObj.ballPercent = d.ballPercent;
      pathObj.curveLength = d.curveLength;

      pathObj.endDistance = pathObj.arcLengths[pathObj.arcLengths.length - 1];
      this.totalLineLength = pathObj.endDistance;

      this.pathDataArr.push(pathObj);
    }

    // store percentage of total track path for each curve
    for (let p = 0; p < this.pathDataArr.length; p++) {
      const pData = this.pathDataArr[p];
      pData.percentOfTrack = pData.curveLength / this.totalLineLength;
      pData.endPercent = pData.endDistance / this.totalLineLength;
      pData.startPercent = pData.startDistance / this.totalLineLength;
    }

    this.trackBallPercent = gameData.BALL_SIZE / this.totalLineLength;

    /* this.debugShape.graphics.beginFill("#0F0");
        this.debugShape.graphics.drawRect(this.paths[0][6],this.paths[0][7],20,20);
        this.debugShape.graphics.endFill();

        this.drawLines(); */
  }

  drawLines() {
    // this.debugShape.graphics.clear();
    this.debugShape.graphics.beginFill('#FFF');

    for (let i = 0; i < this.paths.length; i++) {
      this.debugShape.graphics.beginFill('#FFF');
      const path = this.paths[i];
      const startPoint = this.getCurvePoint(path,0.01);
      this.debugShape.graphics.drawRect(startPoint.x,startPoint.y,10,10);
      const midPoint = this.getCurvePoint(path,.5);
      this.debugShape.graphics.drawCircle(midPoint.x,midPoint.y,10);
      this.debugShape.graphics.endFill();
      this.debugShape.graphics.beginFill('#F00');
      const endPoint = this.getCurvePoint(path,1);
      this.debugShape.graphics.drawRect(endPoint.x,endPoint.y,10,10);
      this.debugShape.graphics.endFill();

      this.debugShape.graphics.setStrokeStyle(2);
      this.debugShape.graphics.beginStroke('#000');

      this.debugShape.graphics.moveTo(path[0],path[1]);
      this.debugShape.graphics.bezierCurveTo(path[2],path[3],path[4],path[5],path[6],path[7]);
      this.debugShape.graphics.endStroke();

      const t = 0.01;
      for (let j = 0; j < 100; j++) {
        const linePoint = this.getCurvePoint(path, t * j);
        this.debugShape.graphics.beginFill('#00F');
        this.debugShape.graphics.drawCircle(linePoint.x,linePoint.y,2);
        this.debugShape.graphics.endFill();
      }
    }
  };

  // returns all data needed for curve, total length, arc length array and ball size percent of curve
  getCurveData(curve,curveStartLength) {
    let totalLength = 0;

    let lastX = this.getCurvePoint(curve,0).x;
    let lastY = this.getCurvePoint(curve,0).y;
    const t = 0.01;
    const arcLengths = [];

    // store arc lengths for curve
    // loop and get curve pt for each hundreth
    for (let i = 0; i <= 100; i++) {
      const nextPt = this.getCurvePoint(curve,i * t);
      const nextX = nextPt.x;
      const nextY = nextPt.y;

      // get distance from last pt to new pt
      const distX = nextX - lastX;
      const distY = nextY - lastY;
      const dist = Math.sqrt((distX * distX) + (distY * distY));

      // add to total distance
      totalLength += dist;
      arcLengths.push(curveStartLength + totalLength);
      lastX = nextX;
      lastY = nextY;
    }
    const ballPercent = (gameData.BALL_SIZE * 2) / totalLength;

    const pathData = { arcLengths,ballPercent,curveLength: totalLength };
    return pathData;
  };

  getCurveLength(curve) {
    let totalLength = 0;

    let lastX = this.getCurvePoint(curve,0).x;
    let lastY = this.getCurvePoint(curve,0).y;
    const t = 0.01;

    // store arc lengths for curve
    // loop and get curve pt for each hundreth
    for (let i = 0; i <= 100; i++) {
      const nextPt = this.getCurvePoint(curve,i * t);
      const nextX = nextPt.x;
      const nextY = nextPt.y;

      // get distance from last pt to new pt
      const distX = nextX - lastX;
      const distY = nextY - lastY;
      const dist = Math.sqrt((distX * distX) + (distY * distY));

      // add to total distance
      totalLength += dist;
      lastX = nextX;
      lastY = nextY;
    }

    return totalLength;
  };

  getTrackPoint(start,ballIndex) {
    // find percent for start, what if not on first path???
    const startPercent = this.getTrackPercent(start);
    const ballPercent = startPercent + (ballIndex * this.trackBallPercent);

    // find current segment

    let i = 0;
    while (this.pathDataArr[i].endPercent < ballPercent) {
      i++;
    }

    const curPath = this.pathDataArr[i];

    const percentOfCurPath = (ballPercent - curPath.startPercent) / curPath.percentOfTrack;
    const trackPt = this.getCurvePoint(curPath.points,percentOfCurPath);

    return trackPt;
  };

  getTrackPercent(dist) {
    return dist / this.totalLineLength;
  };

  getEvenTrackPoint(dist) {
    let i = 0;
    while (this.pathDataArr[i].endDistance < dist) {
      i++;
    }
    const curPath = this.pathDataArr[i];
    const trackPt = this.getEvenCurvePoint(curPath,dist);
    const trackInfo = { curvePt: trackPt.curvePt,curveSegIndex: trackPt.curveSegIndex,pathSegIndex: i };

    return trackInfo;
  };

  getEvenCurvePoint(curveData,dist) {
    let t = 0;
    let i = 1;
    while (curveData.arcLengths[i - 1] < dist) {
      i++;
    }

    if (curveData.arcLengths[i - 1] > dist) i--;
    const nextSeg = curveData.arcLengths.length > i ? curveData.arcLengths[i] : this.pathDataArr[this.pathDataArr.indexOf(curveData) + 1].startDistance;

    const lastLength = curveData.arcLengths[i - 1];

    // if(nextSeg < lastLength) nextSeg = lastLength + 1;
    if (lastLength === dist) {
      t = i / 100;
    }
    else {
      const nextLength = curveData.arcLengths.length > i ? curveData.arcLengths[i] : this.pathDataArr[this.pathDataArr.indexOf(curveData) + 1].arcLengths[0];
      t = (i + (dist - lastLength) / (nextSeg - lastLength)) / 100;

    }

    const curvePt = this.getCurvePoint(curveData.points,t);
    if (!curvePt.x) {
      const onPoint = lastLength === dist;
    }

    const positionData = { curvePt,curveSegIndex: i };
    return positionData;
  };

  getStoredDistance(pathIndex,curveIndex) {
    const d = this.pathDataArr[pathIndex].arcLengths[curveIndex];

    return d;
  };

  getCurvePoint(curve,percent) {
    const a = { x: curve[0],y: curve[1] };
    const b = { x: curve[2],y: curve[3] };
    const c = { x: curve[4],y: curve[5] };
    const d = { x: curve[6],y: curve[7] };

    const pX = (a.x * this.b1(percent)) + (b.x * this.b2(percent)) + (c.x * this.b3(percent)) + (d.x * this.b4(percent));
    const pY = (a.y * this.b1(percent)) + (b.y * this.b2(percent)) + (c.y * this.b3(percent)) + (d.y * this.b4(percent));

    return { x: pX,y: pY };
  };

  bezierPoint(curve, percent) {
    const a = { x: curve[0],y: curve[1] };
    const b = { x: curve[2],y: curve[3] };
    const c = { x: curve[4],y: curve[5] };
    const d = { x: curve[6],y: curve[7] };

    const bCurve = [a,b,c,d];
  };

  // bezier helpers, cubic only
  // TODO make function for whatever order , also make static? global?
  b1(t) {
    return (1 - t) * (1 - t) * (1 - t);
  };

  b2(t) {
    return 3 * (1 - t) * (1 - t) * t;
  };

  b3(t) {
    return 3 * (1 - t) * (t * t);
  };

  b4(t) {
    return t * t * t;
  };
}